import React from 'react';
import { Filter, ArrowUpDown, RefreshCw } from 'lucide-react';
import { SPEND_TIERS } from './spendTiers';

// Categories come from the schema CHECK constraint on classification_flags.
const CATEGORIES = [
  { value: 'all', label: 'All categories' },
  { value: 'wrong_vendor', label: 'Wrong vendor' },
  { value: 'wrong_category', label: 'Wrong category' },
  { value: 'wrong_product', label: 'Wrong product' },
  { value: 'ambiguous', label: 'Ambiguous' },
  { value: 'non_tech', label: 'Non-tech' },
  { value: 'duplicate', label: 'Duplicate' },
  { value: 'other', label: 'Other' },
];

const SORTS = [
  { value: 'priority', label: 'Priority (default)' },
  { value: 'amount_desc', label: 'Amount (high → low)' },
  { value: 'age_desc', label: 'Age (oldest first)' },
  { value: 'flag_count_desc', label: 'Flag count' },
];

function FlagFilters({ value, onChange, onRefresh, isLoading }) {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="fr-filters">
      <div className="fr-filter">
        <Filter size={12} className="fr-filter__icon" />
        <label className="fr-filter__label">Category</label>
        <select
          className="fr-filter__select"
          value={value.category}
          onChange={(e) => set({ category: e.target.value })}
        >
          {CATEGORIES.map(c => (
            <option key={c.value} value={c.value}>{c.label}</option>
          ))}
        </select>
      </div>

      <div className="fr-filter">
        <label className="fr-filter__label">Tier</label>
        <select
          className="fr-filter__select"
          value={value.tier}
          onChange={(e) => set({ tier: e.target.value })}
          title="Spend tier from CLASSIFICATION_NORTH_STAR.md"
        >
          <option value="all">All tiers</option>
          {SPEND_TIERS.map(t => (
            <option key={t.key} value={t.key}>
              {t.label} — {t.description}
            </option>
          ))}
        </select>
      </div>

      <div className="fr-filter">
        <ArrowUpDown size={12} className="fr-filter__icon" />
        <label className="fr-filter__label">Sort</label>
        <select
          className="fr-filter__select"
          value={value.sort}
          onChange={(e) => set({ sort: e.target.value })}
        >
          {SORTS.map(s => (
            <option key={s.value} value={s.value}>{s.label}</option>
          ))}
        </select>
      </div>

      <button
        className="fr-filter__refresh"
        onClick={onRefresh}
        disabled={isLoading}
        title="Refresh queue"
      >
        <RefreshCw size={14} className={isLoading ? 'fr-spin' : ''} />
      </button>
    </div>
  );
}

export default FlagFilters;
